// Oturum çözülünce dili yeniden değerlendir.
//
// /ops/v1/me zaten `locale` döndürüyordu ve konsol onu hiç okumuyordu.
// Burada customer-web'den farklı olarak yeni bir sorgu AÇILMAZ: useOperatorMe
// tam payload'ı zaten cache'liyor (queryKey ["operator","me"]), dilim oradan
// okunur.
//
// KULLANICI SEÇİMİ EZİLMEZ: saklanmış seçim varsa hook karışmaz.

import { useEffect } from "react";

import { cacheResolvedLocale, readStoredLocale, resolveAppLocale } from "@novemai/i18n-sdk";

import { useOperatorMe } from "@/hooks/useOperatorMe";

import { i18n, OPERATOR_APP_DEFAULT_LOCALE } from "./index.ts";
import { localeStorage } from "./locale-storage.ts";

export function useApplyResolvedLocale(): void {
  const { data } = useOperatorMe();
  const claimLocale = data?.locale ?? undefined;

  useEffect(() => {
    if (readStoredLocale(localeStorage) !== undefined) return;
    if (claimLocale === undefined) return;
    const resolved = resolveAppLocale({
      userPref: claimLocale,
      browserPreferences:
        typeof navigator === "undefined" ? [] : Array.from(navigator.languages ?? []),
      appDefault: OPERATOR_APP_DEFAULT_LOCALE,
    });
    // Bir sonraki boot claim'i beklemeden doğru dili boyayabilsin diye.
    cacheResolvedLocale(resolved, localeStorage);
    if (resolved !== i18n.language) {
      void i18n.changeLanguage(resolved);
    }
  }, [claimLocale]);
}
